/* @flow */
export const Signature = {
  explanation: 'Only class participants see your signature on Remind.',
};



// WEBPACK FOOTER //
// ./src/constants/CopyConstants.js